export default "/accountant-bg.9221a3b7a02e080a491fc5fb2b0d919d.png";